/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    _new?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    accepted?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    veto?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    other?: number;
}

export function InlineResponse2002FromJSON(json: any): InlineResponse2002 {
    return InlineResponse2002FromJSONTyped(json, false);
}

export function InlineResponse2002FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2002 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        '_new': !exists(json, 'new') ? undefined : json['new'],
        'accepted': !exists(json, 'accepted') ? undefined : json['accepted'],
        'veto': !exists(json, 'veto') ? undefined : json['veto'],
        'other': !exists(json, 'other') ? undefined : json['other'],
    };
}

export function InlineResponse2002ToJSON(value?: InlineResponse2002 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'new': value._new,
        'accepted': value.accepted,
        'veto': value.veto,
        'other': value.other,
    };
}


